import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { NotificationBannerConfig } from './@models/notification-banner-config.model';

@Injectable({ providedIn: 'root' })
export class NotificationBannerService {
  private configs: NotificationBannerConfig[] = [];
  private visibleBannersIds: string[] = [];

  visibleBannersIds$ = new BehaviorSubject<string[]>(this.visibleBannersIds);
  configs$ = new BehaviorSubject<NotificationBannerConfig[]>(this.configs);

  getBannerConfig(id: string): NotificationBannerConfig {
    const config = this.configs.find((x) => x.alertId === id);

    if (!config) {
      throw new Error('No Config instance with this ID!');
    }

    return config;
  }

  showSubtile(newValue: boolean, alertId: string): void {
    const config = this.getBannerConfig(alertId);
    var index = this.configs.indexOf(config);
    this.configs[index].isSubtle = newValue;
    this.configs$.next(this.configs);
  }

  setup(config: NotificationBannerConfig): void {
    this.addConfig(config);
  }

  closeNotificationBanner(alertId: string): void {
    this.visibleBannersIds$.next(
      this.visibleBannersIds.filter((id) => id !== alertId)
    );
  }

  private addConfig(config: NotificationBannerConfig): void {
    const configs = this.configs
      .filter((x) => x.alertId !== config.alertId)
      .concat(config);

    this.configs = configs;
    this.configs$.next(configs);

    this.show(config.alertId);
  }

  private show(alertId: string): void {
    var index = this.visibleBannersIds.indexOf(alertId);

    if (index === -1) {
      this.visibleBannersIds.push(alertId);
      this.visibleBannersIds$.next(this.visibleBannersIds);
    }
  }
}
